<template>
  <Modal variant="dashboard" @close="close">
    <template slot="content">
      <div class="p-dashboard-form">
        <div class="p-dashboard-form__header">
          <h2 class="p-dashboard-form__title">
            実施したタスクを完了しましょう
          </h2>
        </div>
        <div class="p-dashboard-form__content">
          <div class="c-fieldset c-fieldset--wrap">
            <div class="c-fieldset__header">
              <p class="c-fieldset__title">施策完了日を変更する</p>
            </div>
            <div class="c-fieldset__content">
              <DatePicker v-model="params.typeDoneDate" />
            </div>
          </div>
        </div>
        <div class="p-dashboard-form__footer c-alertPos">
          <Button
            class="p-dashboard-form__cancel"
            @click="close"
            target="_blank"
            size="w80"
            fsizse="f16"
            variant="back"
            radius
          >
            戻る
          </Button>
          <Button
            class="p-dashboard-form"
            @click="submit"
            target="_blank"
            size="w180"
            fsizse="f16"
            variant="back"
            radius
            :disabled="this.isProcessing"
            :class="{
              'is-active': !this.isProcessing,
              'is-loading': this.isProcessing
            }"
          >
            タスクを完了する
          </Button>
          <Alert v-if="errorResponse">
            {{ errorResponse }}
          </Alert>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import DatePicker from '@/components/DatePicker';
import Modal from '@/components/Modal';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    DatePicker,
    Modal
  },
  data() {
    return {
      errorResponse: '',
      params: {
        typeDoneDate: this.item.typeDoneDate
          ? new Date(this.item.typeDoneDate)
          : new Date()
      },
      isEdited: {
        typeDoneDate: false
      },
      isProcessing: false
    };
  },

  watch: {
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.errorResponse = '';
      },
      deep: true
    },
    'params.typeDoneDate': {
      handler(value, oldValue) {
        if (this.item.typeDoneDate) {
          this.isEdited.typeDoneDate =
            utils.formatDate(value, 'YYYY-MM-DD') !=
            utils.formatDate(this.item.typeDoneDate, 'YYYY-MM-DD');
        } else {
          this.isEdited.typeDoneDate = !!value;
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    openModalObservationKeyword(item) {
      this.$emit('openModalRegisterObservationKeyword', item);
    },
    async submit() {
      this.isProcessing = true;
      const params = this.getTaskParams();
      const item = Object.assign({}, this.item);

      await apiProjects.tasks
        .put(params, this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          item.column = params.column;
          item.typeDoneDate = params.typeDoneDate;
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          } else {
            this.errorResponse = ERROR_MESSAGE.other;
          }
          this.isProcessing = false;
          return;
        });

      //タスク完了時にエラーが発生したら処理を中断する
      if (this.errorResponse) {
        this.isProcessing = false;
        return;
      }

      const keywordSearchParams = {
        keyword: this.item.keyword,
        url: this.item.url
      };

      const keywordId = await apiProjects.observationKeywords.search
        .get(keywordSearchParams, this.auth.idToken, this.project.id)
        .then(response => response.data.id)
        .catch(error => null);

      // 環境変数のisDemoはstring型
      const isDemo = `${this.$constants.isDemo}` === 'true';

      if (!keywordId || isDemo) {
        //検索順位チェック用のモーダルを開く処理 更新後のオブジェクトを渡す
        this.openModalObservationKeyword(this.item);
      }

      this.isProcessing = false;
      //タスク完了後のタスクの配列から削除
      this.$emit('completeRefineTask', item);
      this.close();
      return;
    },
    getTaskParams() {
      const params = {
        url: this.item.url,
        typeDoneDate: this.params.typeDoneDate
          ? utils.formatDate(this.params.typeDoneDate, 'YYYY-MM-DD')
          : utils.formatDate(new Date(), 'YYYY-MM-DD'),
        // column,type,position,taskDetailがリクエストに必要なので明示的に挿入
        column: 'done',
        type: this.item.type,
        position: 0,
        keyword: this.item.keyword,
        taskDetail: this.item.taskDetail,
        executionDate: this.item.executionDate,
        operatorUserId: this.item.operatorUserId,
        operatorUserName: this.item.operatorUserName,
        note: this.item.note,
        updatedAt: this.item.updatedAt
      };
      return params;
    }
  }
};
</script>
